export default __webpack_public_path__ + "65eb892b6103d031d18e26eae0418cde.png";